'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const baseReset = {
  all: "unset",
  display: "revert",
  boxSizing: "border-box"
};
const boxSizing = {
  boxSizing: "border-box"
};
const interactiveReset = {
  all: "unset",
  display: "revert",
  boxSizing: "border-box",
  cursor: "pointer"
};
const listReset = {
  boxSizing: "border-box",
  listStyle: "none",
  margin: 0,
  padding: 0
};

exports.baseReset = baseReset;
exports.boxSizing = boxSizing;
exports.interactiveReset = interactiveReset;
exports.listReset = listReset;
//# sourceMappingURL=reset.cjs.js.map
